import React from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import MapIcon from '@mui/icons-material/Map';
import { Launch as LaunchIcon } from '@mui/icons-material';

// Custom
import MapCardActionButton from '@/ui/MapCard/MapCardActionButton';
import Permissions from '@/lib/permissions';

// Types
import { DCRecord } from '@/@types/lib/dataController';

type IPPZahtjeviButtonProps = {
  record: DCRecord;
};

const PPZahtjeviButton = (props: IPPZahtjeviButtonProps) => {
  const { t } = useTranslation();

  const { record } = props;

  const url = `/pp/zahtjevi?id=${record.id}`;

  const handleClick = () => {
    window.open(url, '_blank');
  };

  return (
    <MapCardActionButton
      startIcon={<MapIcon />}
      onClick={handleClick}
      aria-label="map"
      disabled={false}
      needPermission={[Permissions.PPZahtjeviView]}
    >
      {t('buttons.go_to_zahtjevi')}
      <LaunchIcon style={{ marginLeft: '7px', width: '16px', height: '16px' }} />
    </MapCardActionButton>
  );
};

export default PPZahtjeviButton;
